import React, { useEffect } from 'react';
import './App.css';
import ReactGA from "react-ga4";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar/Navbar';
import { Footer } from './components/Footer/Footer';
import { Productos } from './components/Productos/Productos';
import { Usuario } from './components/Usuario/Usuario';
import { Favoritos } from './components/Favoritos/Favoritos';
import { Nosotros } from './components/Nosotros/Nosotros';
import { Login } from './components/Login/Login';
import { EligeUsuario } from './components/EligeUsuario/EligeUsuario';
import { Premium } from './components/Premium/Premium';
import { Alertas } from './components/Alertas/Alertas';
import { AvisoLegal } from './components/PaginasLegales/AvisoLegal/AvisoLegal';
import { PoliticaCookies } from './components/PaginasLegales/PoliticaCookies/PoliticaCookies';
import { PoliticaPrivacidad } from './components/PaginasLegales/PoliticaPrivacidad/PoliticaPrivacidad';
import { AfiliadosDashboard } from './components/AfiliadosDashboard/AfiliadosDashboard';
import { RutaPrivada} from './components/RutaPrivada/RutaPrivada';

import { AuthProvider, useAuth } from './context/AuthContext';

function AdsenseLoader() {
  const { premium, loading } = useAuth();

  useEffect(() => {
    if (!loading && !premium) {
      // Ya está cargado
      if (document.getElementById('adsense-script')) return;

      const script = document.createElement("script");
      script.setAttribute("id", "adsense-script");
      script.setAttribute("data-ad-client", "ca-pub-1255089201839493");
      script.async = true;
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      document.head.appendChild(script);
      console.log("AdSense cargado para usuario NO premium");
    }
  }, [premium, loading]);

  return null;
}

function AppContent() {
  return (
    <>
      <header>
        <Navbar />
      </header>

      <Routes>
        <Route path='/' element={<Productos />} />
        <Route path='usuario' element={<RutaPrivada><Usuario /></RutaPrivada>} />
        <Route path='favoritos' element={<RutaPrivada><Favoritos /></RutaPrivada>} />
        <Route path='nosotros' element={<Nosotros />} />
        <Route path='login' element={<Login />} />
        <Route path='elige-usuario' element={<EligeUsuario />} />
        <Route path='premium' element={<Premium />} />
        <Route path='alertas' element={<RutaPrivada><Alertas /></RutaPrivada>} />
        <Route path='aviso-legal' element={<AvisoLegal />} />
        <Route path='politica-cookies' element={<PoliticaCookies />} />
        <Route path='politica-privacidad' element={<PoliticaPrivacidad />} />
        <Route path='afiliados-dashboard' element={<AfiliadosDashboard />} />
      </Routes>

      <Footer />
    </>
  );
}

function App() {
  ReactGA.initialize("G-ZENR43C1PL");
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AdsenseLoader />
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
